// Orchestrated, restrained scroll reveals. Only ever animates opacity/transform
// (never layout-affecting properties), and is skipped entirely when
// prefers-reduced-motion is set (see main.js gate).
export function initReveals(gsap) {
  const items = gsap.utils.toArray("[data-reveal]");
  if (!items.length) return;

  items.forEach((el, i) => {
    gsap.fromTo(
      el,
      { opacity: 0, y: 24 },
      {
        opacity: 1,
        y: 0,
        duration: 0.7,
        ease: "power2.out",
        delay: (i % 3) * 0.05,
        scrollTrigger: {
          trigger: el,
          start: "top 88%",
          once: true,
        },
      }
    );
  });

  const heroEls = gsap.utils.toArray("[data-reveal-hero]");
  if (heroEls.length) {
    gsap.fromTo(
      heroEls,
      { opacity: 0, y: 18 },
      { opacity: 1, y: 0, duration: 0.8, stagger: 0.08, ease: "power3.out", delay: 0.1 }
    );
  }
}
